import {observer} from 'mobx-react';
import React from 'react';
import {X1LanguageSelect} from '../../../../lib/components';
import {X1LanguageStore} from '../X1LanguageStore';

@observer
export class MoveAgeCategoryForm extends React.Component<{ store: X1LanguageStore }> {
  render() {
    const {store} = this.props;

    if (store.move === null)
      return null;

    const move = store.move;
    return (
      <div className="row" key="move-form">
        <div className="col">
          <div className={move.language.formGroupClassName}>
            <X1LanguageSelect options={move.languageOptions}
                              value={move.language.value}
                              onChange={move.language.setValue}/>
            <div className="invalid-text">Enter language</div>
          </div>
        </div>
      </div>
    );
  }
}
